import useGetCustomerProfileApi from '@/api/sirta/customerPage/useGetCustomerProfile.api';
import { shallowRef, watch } from 'vue';
import useCustomerStore from '@/store/customer.store';

export default function useCustomerProvider() {
  const { apiResponse, fetchData } = useGetCustomerProfileApi({ immediate: false, onError: () => {} });
  const { setCustomer, resetCustomer } = useCustomerStore();
  const fetchState = shallowRef(fetchData());

  /**
   * Mise à jour des données du profil de l'utilisateur.
   */
  async function refresh() {
    return !fetchState.value.isLoading.value
      ? fetchState.value.execute()
      : Promise.resolve(apiResponse);
  }

  watch(apiResponse, ({ data: newProfile }) => {
    if (newProfile) {
      setCustomer(newProfile);
    }
  });

  return {
    refresh,
    fetchState,
    resetCustomer,
  };
}
